module.exports = __webpack_public_path__ + "img/final-skull.5f24d9f2.png";